import { FDSColors } from '@fountain/fds-tokens';
import { StatusLabelPalette } from 'src/types';

const cssVar = (token: string, hex: string) =>
  `var(--ds-color-${token}, ${hex})`;

export const CustomColors = {
  amber50: '#FFF8E1',
  amber800: '#92400E',
};

export interface AvatarColors {
  BLUE_1: string;
  GREEN_1: string;
  GREEN_2: string;
  ORANGE: string;
  ORANGE_2: string;
  PINK: string;
  PURPLE: string;
  RED: string;
  TEAL: string;
}

export interface IconColors {
  GREEN_100: string;
  PURPLE_200: string;
  PINK_100: string;
  PURPLE_100: string;
}

export interface SpecialColors {
  Avatar: AvatarColors;
  Icon: IconColors;
  StatusLabel: StatusLabelPalette;
}

export const SpecialColors: SpecialColors = {
  Avatar: {
    BLUE_1: '#4147D9',
    GREEN_1: '#188038',
    GREEN_2: '#2EC73E',
    ORANGE: '#FBB32B',
    ORANGE_2: '#F25D09',
    PINK: '#FD22C1',
    PURPLE: '#8B4FFB',
    RED: '#F63063',
    TEAL: '#2EC9C2',
  },
  Icon: {
    GREEN_100: 'rgba(153, 207, 0, 0.16)',
    PINK_100: 'rgba(242, 85, 236, 0.16)',
    PURPLE_100: 'rgba(151, 101, 255, 0.16)',
    PURPLE_200: 'rgba(76, 83, 255, 0.16)',
  },
  // PARTNER hovers a rung darker than it used to: gray200 and gray300 both
  // resolve to neutral-200 under the Ripple mapping, which left its resting
  // and hover states identical. The rest tone cannot move down instead —
  // gray100 is the applicant table's own row-hover background, so the label
  // would dissolve into a hovered row.
  StatusLabel: {
    HoverColor: {
      ACTION: FDSColors.blue500,
      INCOMPLETE: cssVar('amber-100', '#fef3c7'),
      IN_PROGRESS: cssVar('purple-100', '#f2d9ff'),
      PARTNER: FDSColors.gray400, // grey
      SUCCESS: cssVar('green-100', '#c3f4bc'),
      WARNING: cssVar('rose-100', '#ffe4e6'),
    },
    IconColor: {
      ACTION: FDSColors.white,
      INCOMPLETE: cssVar('amber-800', '#92400e'),
      IN_PROGRESS: cssVar('purple-800', '#5b00a3'),
      PARTNER: FDSColors.gray800, // grey
      SUCCESS: cssVar('green-600', '#3e8334'),
      WARNING: cssVar('rose-800', '#9f1239'),
    },
    LabelColor: {
      ACTION: FDSColors.blue400,
      INCOMPLETE: cssVar('amber-50', '#fff8e1'),
      IN_PROGRESS: cssVar('purple-50', '#f4e6ff'),
      PARTNER: FDSColors.gray200, // grey
      SUCCESS: cssVar('green-50', '#d8f9d3'),
      WARNING: cssVar('rose-50', '#fff1f2'),
    },
  },
};

export const Fonts = {
  ARIAL: 'Arial',
  BOLD: 'CircularXXWeb-Bold',
  BOOK: 'CircularXXWeb-Book',
  HELVETICA: 'Helvetica',
  HELVETICA_NEUE: 'Helvetica Neue',
  MEDIUM: 'CircularXXWeb-Medium',
  SANS: 'sans-serif',
};

export const fallbackFamily = `${Fonts.HELVETICA_NEUE},${Fonts.HELVETICA},${Fonts.ARIAL},${Fonts.SANS}`;
export const bookFamily = `${Fonts.BOOK},${fallbackFamily}`;
export const boldFamily = `${Fonts.BOLD},${fallbackFamily}`;
export const mediumFamily = `${Fonts.MEDIUM},${fallbackFamily}`;
